import { Box } from "@mui/material";

import { FormBlock } from "@/forms-design-system/FormBlock/FormBlock";
import { useMediaQuery } from "@/hooks/useMediaQuery";

type ThemedDonationFormSummaryLayoutProps = {
  slots: {
    banner?: React.ReactNode;
    organizationLogo?: React.ReactNode;
    status?: React.ReactNode;
    title: React.ReactNode;
    campaignTarget?: React.ReactNode;
    peerCredibilityChipGuestsCount?: React.ReactNode;
    description?: React.ReactNode;
  };
  forceInlined?: boolean;
};

export const ThemedDonationFormSummaryLayout = ({
  slots,
  forceInlined = false,
}: ThemedDonationFormSummaryLayoutProps) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <FormBlock
      variant={isSmallScreen || forceInlined ? "inline" : "elevated-card"}
      fullWidth
      sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2 }}
    >
      {!isSmallScreen && slots.banner}
      {isSmallScreen && slots.organizationLogo}
      {slots.status && <Box marginBlockStart={0.5}>{slots.status}</Box>}
      {slots.title}
      {slots.peerCredibilityChipGuestsCount}
      {slots.campaignTarget}
      {slots.description}
    </FormBlock>
  );
};
